import React from 'react'
import { injectIntl } from "gatsby-plugin-intl"

class Back extends React.Component {


    toPrevious(e) {
        window.location.href = origin
    }

    render() {
        const { intl } = this.props
        const style = {
            color: "#666",
            cursor: "pointer"
        }

        return (
            <div className="container">
                <span style={style} onClick={this.toPrevious}>{intl.formatMessage({id: "util.Back"})}</span>
            </div>
        )
    }
}

export default injectIntl(Back)
